import React, { useState } from 'react';
import PropTypes from 'prop-types';

import config from '../../config';
import LogoImageMobile from './logo-main.png';
import LogoMainImage from './logo-main.png';
import LogoFooterImage from './logo-footer.png';
import css from './Logo.module.css';

const Logo = props => {
  const { className, format, darkBackground, ...rest } = props;

  if (format === 'desktop') {
    return <img className={className} src={LogoMainImage} alt={config.siteTitle} {...rest} />
    //return <p className={darkBackground ? css.logoLight : css.logo}>ROTATE</p>;
  } else if (format === 'desktopFooter') {
    return <img className={className || css.logoMobile} src={LogoFooterImage} alt={config.siteTitle} {...rest} />
    //return <p className={darkBackground ? css.logoLightFooter : css.logoFooter}>R</p>;
  }

  // return <img className={className} src={LogoImageMobile} alt={config.siteTitle} {...rest} />;
  return <img className={className || css.logoMobile} src={LogoImageMobile} alt={config.siteTitle} {...rest} />
};

const { oneOf, string } = PropTypes;

Logo.defaultProps = {
  className: null,
  format: 'desktop',
};

Logo.propTypes = {
  className: string,
  format: oneOf(['desktop', 'desktopFooter', 'mobile']),
};

export default Logo;
